module.exports = __webpack_public_path__ + "static/media/deciduous-tree_1f333.e776409a.png";